import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { LandingPage } from './pages/LandingPage';
import { TemplateSelection } from './pages/TemplateSelection';
import { ResumeEditor } from './pages/ResumeEditor'; // Import the new component

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/templates" element={<TemplateSelection />} />
          <Route path="/editor" element={<ResumeEditor />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
